import {
  DashboardChartsRow,
  FinancialOverviewChart,
  type ChartDatum,
} from "@/components/dashboard";
import SabilTypeChart from "./SabilTypeChart";

export type { ChartDatum };

type ChartsRowProps = {
  financialData: ChartDatum[];
  sabilTypeData: ChartDatum[];
};

const ChartsRow = ({ financialData, sabilTypeData }: ChartsRowProps) => (
  <DashboardChartsRow
    primary={<FinancialOverviewChart data={financialData} />}
    secondary={<SabilTypeChart data={sabilTypeData} />}
  />
);

export default ChartsRow;
